<template>
  <div class="myChoicePrivate">

      <img src="@/assets/images/development.png" alt="" style="margin:100px 500px;">

  </div>
</template>

<script>
    export default {
        name: "myChoicePrivate"
    }
</script>

<style scoped>

</style>
